import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Position, Handle } from "reactflow";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import "./styles.css";
import SelIcon from "../../Components/Bot/SelIcon";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import SkipNextIcon from "@mui/icons-material/SkipNext";

interface CustomNodeProps {
  id: String;
  data: any;
}

function CustomNode({ id, data }: CustomNodeProps) {
  const [preSignedImageUrl, setPreSignedImageUrl] = useState("");
  const onDelete = useCallback(
    (info: any) => {
      data.onDeleteNode(info);
    },
    [data]
  );
  const onEdit = useCallback(
    (info: any) => {
      data.onEdit(info);
    },
    [data]
  );
  console.log(data);
  let strMsg: string = data.textMessage;
  try {
    if (strMsg.charCodeAt(data.textMessage.indexOf("\n")) === 10) {
      strMsg = data.textMessage.split("\n").join("\\n");
    }
  } catch (e) {}

  let imgObjKey: string = data.imgObjKey;
  const actionOrRandom =
    data.supporterCheck || data.detractorCheck || data?.randomizer?.length > 0;
  const action = data.supporterCheck === true || data.detractorCheck === true;
  const random = data?.randomizer?.length > 0;
  const image = data.imageUrl;
  let image1: any = "../assets/images/users/avatar-5.jpg";
  const isSubscribeOptin = data?.skipForSubscribers;
  const isTimeChecked = data?.checked;
  const isOptinChecked = data?.isChecked;
  useEffect(() => {
    if (imgObjKey && data.fileName !== "No file chosen") {
      const params = `imageObjectKey=${imgObjKey}`;
      try {
        NetworkManager.sendJsonRequest(
          "generatePreSignedImageUrl",
          "",
          params,
          "GET",
          true,
          (data: any) => {
            const respData = CommonUtil.parseData(data);
            if (respData) {
              setPreSignedImageUrl(respData.preSignedImageUrl);
            }
          },
          () => {
            console.error("Error while fetching pre-signed URL");
          }
        );
      } catch (error) {
        console.error("Unexpected error:", error);
      }
    }
  }, [imgObjKey, data.fileName]);

  const panel = useMemo(() => {
    return (
      <>
        <Card
          sx={{
            maxWidth: actionOrRandom ? 250 : 345,
            p: actionOrRandom ? "" : "5px",
            backgroundColor: actionOrRandom ? "white" : undefined,
          }}
          className={action ? "actions-panel" : "campaign-panel"}>
          <Handle
            type="target"
            position={Position.Left}
            id="t1"
            style={{ top: 20 }}
          />
          <div
            className="wrap"
            style={{
              height: actionOrRandom ? "60px" : undefined,
              backgroundColor: action
                ? data.detractorCheck
                  ? "#fd6c33"
                  : "#10ae10"
                : random
                ? "#b0e1ef"
                : undefined,
            }}>
            <div className="main-title">
              <span className="icon">
                {/* <img alt="" src={chatIcon} width={23} height={23} /> */}
                {actionOrRandom ? "" : <SelIcon />}
              </span>
              {action ? (
                <div>
                  <h6
                    style={{
                      marginLeft: "16px",
                      fontSize: "18px",
                      fontWeight: 1000,
                    }}>
                    Actions
                  </h6>
                </div>
              ) : random ? (
                <div>
                  <h6
                    style={{
                      marginLeft: "16px",
                      fontSize: "17px",
                      fontWeight: 600,
                    }}>
                    A/B Test
                  </h6>
                </div>
              ) : (
                <span className="text" style={{ paddingLeft: "5px" }}>
                  {data.cardName}
                </span>
              )}

              {isSubscribeOptin && (
                <SkipNextIcon
                  sx={{
                    position: "absolute",
                    left: 125,
                    top: 12,
                    fontSize: "1.8rem",
                  }}
                />
              )}

              {isTimeChecked && (
                <AccessTimeFilledIcon
                  sx={{
                    position: "absolute",
                    left: 170,
                    top: 12,
                  }}
                />
              )}
              {data?.textMessage !== "Start Node" ? (
                <>
                  <button
                    type="button"
                    style={{
                      position: "absolute",
                      left: actionOrRandom ? "190px" : "250px",
                      top: "6px",
                      borderStyle: "none",
                    }}
                    className={
                      actionOrRandom
                        ? "btn btn-outline-dark rounded-circle"
                        : "btn btn-outline-danger rounded-circle"
                    }
                    onClick={() => onDelete(data)}>
                    <span style={{ fontWeight: "900", fontSize: "15px" }}>
                      X
                    </span>
                  </button>
                  <button
                    type="button"
                    style={{
                      position: "absolute",
                      left: actionOrRandom ? "130px" : "200px",
                      top: "6px",
                      borderStyle: "none",
                    }}
                    className="btn btn-outline-secondary rounded-circle"
                    onClick={(e) => { e.currentTarget.blur(); onEdit(data); }}>
                    <span
                      style={{
                        fontWeight: "900",
                        fontSize: "15px",
                        borderStyle: "none",
                      }}>
                      <ModeEditIcon />
                    </span>
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          <CardContent
            sx={{
              p: actionOrRandom ? "0px !important" : "16px !important",
            }}>
            <Card
              sx={{
                p: image || image1 ? "0px" : "10px",
                display: isOptinChecked || actionOrRandom ? "none" : "block",
                textAlign:
                  data.textMessage !== "Start Node" ? "left" : "center",
              }}>
              {data.genericChecked ? (
                <Box
                  sx={{
                    display:
                      data.textMessage !== "Start Node" ? "block" : "none",
                  }}>
                  <CardMedia
                    component="img"
                    // alt="green iguana"
                    height="100"
                    image={image}
                  />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      pl: 1,
                      mt: 1.5,
                      fontSize: "1.05rem",
                      fontWeight: 600,
                    }}>
                    {data.genericTitle}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ pl: 1, mt: 0.5 }}>
                    {data.genericSubTitle}
                  </Typography>
                </Box>
              ) : data.mediaChecked ? (
                <Box
                  sx={{
                    display:
                      data.textMessage !== "Start Node" ? "block" : "none",
                  }}>
                  <CardMedia
                    component="img"
                    // alt="green iguana"
                    height="100"
                    image={preSignedImageUrl ? preSignedImageUrl : image}
                  />
                </Box>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ pl: 1, mt: 1 }}>
                  {data.textMessage
                    .split("\n")
                    .map((line: string, index: number) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                </Typography>
              )}
              <CardActions>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "5px",
                    width: "-webkit-fill-available",
                  }}>
                  {data?.multipleButton &&
                    data.multipleButton.map((multData: any, i: any) => {
                      const btns = multData.buttonType;

                      return (
                        <React.Fragment key={i}>
                          {btns !== "QUICK_REPLIES" ? (
                            <Button
                              variant="outlined"
                              size="large"
                              className="rounded-corner-10"
                              key={i}>
                              {multData.multiButton}
                              {btns === "postback" ? (
                                <Handle
                                  type="source"
                                  position={Position.Right}
                                  id={`${multData.id}`}
                                  style={{ bottom: 10 }}
                                />
                              ) : null}
                            </Button>
                          ) : null}
                        </React.Fragment>
                      );
                    })}
                </Box>
              </CardActions>
            </Card>
            {/* Optin Card start */}
            <Card
              sx={{
                p: image ? "0px" : "10px",
                display: isOptinChecked ? "block" : "none",
                backgroundColor: "#fce6b1",
                textAlign:
                  data.textMessage !== "Start Node" ? "left" : "center",
              }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, pl: 1, mt: 1.5 }}>
                {data.optinTitle}
              </Typography>
              <CardActions>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "5px",
                    width: "-webkit-fill-available",
                  }}>
                  <Button
                    variant="outlined"
                    size="large"
                    className="rounded-corner-10"
                    sx={{ textTransform: "none" }}>
                    {data.ctatext === "GET_UPDATES"
                      ? "Get updates"
                      : data.ctatext === "ALLOW"
                      ? "Allow messages"
                      : data.ctatext === "GET"
                      ? "Get messages"
                      : data.ctatext === "OPT_IN"
                      ? "Opt in to messages"
                      : data.ctatext === "SIGN_UP"
                      ? "Sign up for messages"
                      : ""}
                  </Button>
                </Box>
              </CardActions>
            </Card>
            {/* Optin Card end */}
            {/* Detractor Card start */}
            <Box
              sx={{
                p: "10px",
                display: action ? "block" : "none",
                backgroundColor: data.supporterCheck
                  ? "#bbf5bd"
                  : data.detractorCheck
                  ? "rgb(255 200 178)"
                  : "",
              }}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontWeight: 500,
                  color: "black",
                  textAlign: "center",
                  fontSize: "20px",
                }}>
                {data.detractorCheck ? "Detractor Node" : "Supporter Node"}
              </Typography>
            </Box>
            {/* Detractor Card end */}
            {/* Randomizer Card start */}
            <Card sx={{ display: random ? "block" : "none" }}>
              <CardActions>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "5px",
                    width: "-webkit-fill-available",
                  }}>
                  {data?.randomizer &&
                    data.randomizer.map((variation: any, i: any) => {
                      return (
                        <React.Fragment key={i}>
                          <Button
                            variant="outlined"
                            size="large"
                            className="rounded-corner-10"
                            sx={{ mt: 0.5, mb: 0.5 }}
                            key={i}>
                            <Handle
                              type="source"
                              position={Position.Right}
                              id={`${variation.id}`}
                              style={{ bottom: 10 }}
                            />
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Typography sx={{ mr: 8 }}>
                                {variation.name}
                              </Typography>
                              <Typography sx={{ ml: 8 }}>
                                {Math.floor(variation.percentage)}%
                              </Typography>
                            </Box>
                          </Button>
                        </React.Fragment>
                      );
                    })}
                </Box>
              </CardActions>
            </Card>
            {/* Randomizer Card end */}
          </CardContent>

          <CardActions sx={{ display: actionOrRandom ? "none" : "block" }}>
            <Box
              sx={{
                display: "flex",
                rowGap: "5px",
                flexDirection: "column",
                alignItems: "flex-end",
                width: "-webkit-fill-available",
              }}>
              {data.multipleButton &&
                data.multipleButton
                  .filter(
                    (multData: any) => multData.buttonType === "QUICK_REPLIES"
                  )
                  .map((multDataQR: any, i: any) => {
                    return (
                      <React.Fragment key={i}>
                        {multDataQR.buttonType === "QUICK_REPLIES" ? (
                          <Button
                            size="small"
                            className="rounded-corner-10"
                            onClick={data.onClickQuickReply}
                            key={i}>
                            <Handle
                              type="source"
                              position={Position.Right}
                              id={`${multDataQR.id}`}
                              style={{ bottom: 10 }}
                              key={i}
                            />
                            {multDataQR.multiButton}
                          </Button>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
            </Box>
          </CardActions>
          <CardActions
            sx={{
              backgroundColor: data.supporterCheck
                ? "#bbf5bd"
                : data.detractorCheck
                ? "rgb(255 200 178)"
                : "",
            }}>
            <Box
              sx={{
                display: random ? "none" : "flex",
                rowGap: "5px",
                flexDirection: "column",
                alignItems: "flex-end",
                width: "-webkit-fill-available",
              }}>
              <Button
                size="small"
                className="rounded-corner-10"
                onClick={data.onAddClick}>
                <Handle
                  type="source"
                  position={Position.Right}
                  id="nextStep"
                  style={{ bottom: 10 }}
                />
                Next Step
              </Button>
            </Box>
          </CardActions>
        </Card>
      </>
    );
  }, [
    data,
    onDelete,
    onEdit,
    action,
    actionOrRandom,
    image,
    image1,
    isOptinChecked,
    isSubscribeOptin,
    isTimeChecked,
    preSignedImageUrl,
    random,
  ]);
  return <>{panel}</>;
}

export default memo(CustomNode);
